import styled from "styled-components";

export const InstructionCardTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export const InstructionCardBody = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InstructionCardFieldInfo = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

export const InstructionCardFieldLabel = styled.label`
  color: #4a4a68;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
`;

export const InstructionCardFieldDesc = styled.span`
  color: #4a4a68;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
`;
